/**
 * disclosure — one open/closed boolean with toggle() and close().
 *
 * Markup contract: the x-data root may carry data-initial-open="false" to
 * start closed; anything else starts open. Templates bind `open`, `toggle`
 * and `close` only.
 */
document.addEventListener("alpine:init", () => {
  // Covers the mobile nav drawer, the notification bell panel, dismissible
  // banners, collapsible table groups, "show more" timelines and chip rows.
  Alpine.data("disclosure", () => ({
    open: true,
    init() {
      if (this.$el.dataset.initialOpen === "false") this.open = false;
    },
    toggle() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
  }));
});
